import type { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import type { SearchAllTypesResult } from '@gov-nx/module/page';
import { Button } from '../Button/Button';

export const SearchItemActionResolver = ({
	children,
	action,
	link,
	className,
	ariaLabel,
}: PropsWithChildren<{
	action: SearchAllTypesResult['action'];
	link: SearchAllTypesResult['link'];
	className?: string;
	ariaLabel?: string;
}>) => {
	if (link.to) {
		return (
			<Link
				className={className ? 'search-result ' + className : 'search-result'}
				to={link.to}
				onClick={() => {
					link.onAfterClick?.();
				}}
				target={link.external ? '_blank' : undefined}
				rel={link.external ? 'noopener noreferrer' : undefined}
				aria-label={ariaLabel}>
				{children}
			</Link>
		);
	}
	return (
		<Button
			className={className ? 'search-result ' + className : 'search-result'}
			onClick={action}
			type="link"
			aria-label={ariaLabel}
			aria-haspopup="dialog"
			expanded>
			{children}
		</Button>
	);
};
